import { useQuery } from '@tanstack/react-query';
import { apiGet, qk } from './_client';

/** GET /api/films/{id} — single film with stats + caller permissions (FilmStats). */
export function useFilm(filmId, options = {}) {
  const { enabled, ...rest } = options;
  return useQuery({
    queryKey: qk.film(filmId),
    queryFn: ({ signal }) => apiGet(`/films/${filmId}`, signal),
    enabled: !!filmId && (enabled ?? true),
    ...rest,
  });
}
